module.exports = require("@pb/kit-component-checkbox");